import { createFileRoute } from "@tanstack/react-router";

function School() {
  const { schoolId } = Route.useParams();
  return (
    <div className="panel">
      <div className="text-xs text-slate-400 uppercase tracking-wide mb-1">
        Screen 8 detail
      </div>
      <h1 className="text-2xl font-semibold mb-3">School: {schoolId}</h1>
      <div className="stub">
        Phase 4: per-school camp history + 8-stage funnel + activation window
        progress.
      </div>
    </div>
  );
}

export const Route = createFileRoute("/schools/$schoolId")({ component: School });
